<h2 mat-dialog-title>Delete {{ data.type }}</h2>
<mat-dialog-content>
  <p>Are you sure you want to delete this {{ data.type }}{{ data.name ? ' (' + data.name + ')' : '' }}?</p>
</mat-dialog-content>
<mat-dialog-actions class="flex-end-actions">
  <button mat-raised-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="warn" (click)="onConfirmClick()">Delete</button>
</mat-dialog-actions>
